var _rect, _g, _mask;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.0833733264974 79.63751480998542",
    width: 258.1667466529948,
    height: 159.27502961997084,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 129.0833733264974,
    height: 79.63751480998542,
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.294223463749177 11.308354037972151) rotate(0 43.925781249999886 29.39887152777777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.29 -0.17 C-1.93 6.02, -15.23 27.33, -10.14 36.96 C-5.06 46.6, 12.29 57.79, 30.22 57.63 C48.14 57.46, 86.38 39.6, 97.4 35.97 M1.76 -1.31 C0.53 4.56, -12.58 25.34, -7.88 35.28 C-3.18 45.22, 12.35 58.1, 29.96 58.33 C47.58 58.55, 86.43 40.4, 97.79 36.64",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.294223463749177 11.308354037972151) rotate(0 43.925781249999886 29.39887152777777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.27 56.46 C81.15 49.68, 88.97 47.34, 97.79 36.64 M75.27 56.46 C79.13 51.83, 84.99 47.63, 97.79 36.64",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.294223463749177 11.308354037972151) rotate(0 43.925781249999886 29.39887152777777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.8 37.35 C75.69 35.8, 85.55 38.67, 97.79 36.64 M67.8 37.35 C73.21 36.64, 80.59 36.31, 97.79 36.64",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownRight);
export default __webpack_public_path__ + "static/media/arrowDownRight.2e542b31ed63f57d0ee5eac9cf61ad36.svg";
export { ForwardRef as ReactComponent };